export const SET_STOCKS = 'SET_STOCKS';
export const SET_STOCK = 'SET_STOCK';
export const ADD_STOCK = 'ADD_STOCK';
export const UPDATE_STOCK = 'UPDATE_STOCK';
export const REMOVE_STOCK = 'REMOVE_STOCK';
export const CLEAR_STOCK = 'CLEAR_STOCK';
export const CLEAR_STOCKS = 'CLEAR_STOCKS';
